/* src/app/pages/sso-registration/sso-registration.page.scss */
ion-content > p {
  margin-left: var(--app-page-margin);
  margin-right: var(--app-page-margin);
}
form {
  margin-left: var(--app-page-margin);
  margin-right: var(--app-page-margin);
}
label {
  margin-top: 1em;
}
.stacked-page-action-area {
  margin-top: 1em;
}
app-accept-terms-input {
  margin: 1.5em 0;
}
.validation-error {
  margin: 0.5em 0;
}
/*# sourceMappingURL=sso-registration.page.css.map */
